import React, { useState, useEffect } from 'react'

//apexcharts
import ReactApexChart from "react-apexcharts"

//moment js
import moment from 'moment'
import 'moment/locale/ru'
moment.locale('ru')


const ApexChart = ({sortedData})=> {

  const [series1, setSeries1] = useState([])
  const [series2, setSeries2] = useState([])


  // options
  const [options, setOptions] = useState({
    chart: {
        toolbar: {
            show: true
        },
        height: 350,
        stacked: false,
        id: "push",
    },
    dataLabels: {
        enabled: false
    },
    tooltip: {
        y:{
            formatter: function(value, series) {
                return new Intl.NumberFormat('ru-RU').format(value);
            }
        }
    },
    title: {
        text: 'Общая статистика',
        align: 'left'
    },
    subtitle: {
        text: 'Запросы / Подписались / Уведомлений показано / Клики',
        align: 'left'
    },
    colors: [
        '#31c971', '#14bae4', '#f4c414', '#f39c12'
    ],
    markers: {
        size: 3,
    },
    stroke: {
        width: 2,
        curve: 'smooth'
    },
    xaxis: {
        labels: {
            rotate: 0,
            rotateAlways: false
        },
        categories: []
    },
    tooltip: {
        shared: true,
    },
    yaxis: [
        {
            seriesName: ['Запросы', 'Подписались'],
            axisTicks: {
                show: true,
            },
            axisBorder: {
                show: true,
                color: '#008FFB',
            },
            title: {
                text: 'Запросы',
            },
            axisBorder: { color: '#31c971' },
            labels: {
                formatter: function (value, opts) {
                    if(opts.w && opts.w.globals){
                        const seriesName = opts.w.globals.seriesNames[opts.seriesIndex]

                        if (seriesName === 'CTR') {
                            const factor = 100;
                            const truncated = Math.floor(value * factor) / factor;
                            
                            return truncated.toFixed(2) 
                        }
                    }
                    return Math.round(value);
                }
            },
            tooltip: {
                enabled: false
            },
        },
    ],
    legend: {
      horizontalAlign: 'center',
    }
  })


  // options - bottom
  const [optionsProfit, setOptionsProfit] = useState({
    chart: {
        toolbar: {
            show: true
        },
        height: 350,
        stacked: false,
        id: 'push-profit'
    },
    dataLabels: {
        enabled: false
    },
    tooltip: {
      y:{
        formatter: function(value, series) {
          return new Intl.NumberFormat('ru-RU').format(value);
        }
      }
    },
    title: {
        text: 'Доход',
        align: 'left'
    },
    subtitle: {
        text: 'Доход / Процент подписок',
        align: 'left'
    },
    colors: [
        '#31c971', '#14bae4'
    ],
    markers: {
        size: 3,
    },
    stroke: {
        width: 2,
        curve: 'smooth'
    },
    xaxis: {
        labels: {
            rotate: 0,
            rotateAlways: false
        },
        categories: []
    },
    tooltip: {
        shared: true,
    },
    yaxis: [
        {
            seriesName: ['Доход'],
            axisTicks: {
                show: true,
            },
            axisBorder: {
                show: true,
                color: '#008FFB',
            },
            title: {
                text: 'Доход',
            },
            axisBorder: { color: '#31c971' },
            labels: {
                formatter: function (value) {
                    if (typeof value !== 'number' || isNaN(value)) {
                        return '0.0';
                    }
                    return value.toFixed(1)
                }
              },
            tooltip: {
                enabled: false
            },
        },
        {
            opposite: true,
            seriesName: ['Процент подписок'],
            axisTicks: {
                show: true,
            },
            axisBorder: {
                show: true,
                color: '#008FFB',
            },
            title: {
                text: 'Процент подписок',
            },
            axisBorder: { color: '#31c971' },
            labels: {
                formatter: function (value) {
                    if (typeof value !== 'number' || isNaN(value)) {
                        return '0.0';
                    }
                    return value.toFixed(1)
                }
              },
            tooltip: {
                enabled: false
            },
        },
    ],
    legend: {
      horizontalAlign: 'center'
    }
  })

  
  const setDefaultChartSettings = (dates) =>{

    let datesFormatted = dates.map(date => {
        return moment(new Date(date)).format('DD.MM')
    })

    setOptions(prevOptions => ({
        ...prevOptions,
        xaxis: {
            ...prevOptions.xaxis,
            categories: datesFormatted
        }
    }));

    setOptionsProfit(prevOptions => ({
        ...prevOptions,
        xaxis: {
            ...prevOptions.xaxis,
            categories: datesFormatted
        }
    }));
  }

  useEffect(()=>{

    if (!sortedData || !sortedData.length) return;

    const reversedData = [...sortedData].reverse();

    // dates
    let XaxisDates = []

    // data (top chart)
    let requests = {
        name: 'Запросы',
        type: 'line',
        data: [],
        yAxis: 0
    }

    let subscriptions = {
        name: 'Подписались',
        type: 'line',
        data: []
    }

    let notifications = {
        name: 'Уведомлений показано',
        type: 'line',
        data: []
    }

    let clicks = {
        name: 'Клики',
        type: 'line',
        data: []
    }

    let ctr = {
        name: 'CTR',
        type: 'line',
        data: []
    }

    // data (bottom chart)
    let profit = {
        name: 'Доход',
        type: 'line',
        data: []
    }

    let subscriptions_percent = {
        name: 'Процент подписок',
        type: 'line',
        data: []
    }

    Object.keys(reversedData).forEach(item =>{

        XaxisDates.push(reversedData[item].date)

        if(reversedData[item] == null){
            requests.data.push(0)
            subscriptions.data.push(0)
            notifications.data.push(0)
            clicks.data.push(0)
            profit.data.push(0)
            subscriptions_percent.data.push(0)
            ctr.data.push(0)
        } else {
            requests.data.push(reversedData[item].requests)
            subscriptions.data.push(reversedData[item].subscriptions)
            notifications.data.push(reversedData[item].notifications)
            clicks.data.push(reversedData[item].clicks)
            profit.data.push(reversedData[item].profit)
            subscriptions_percent.data.push(reversedData[item].subscriptions_percent)
            ctr.data.push(reversedData[item].ctr)
        }
    })

    setDefaultChartSettings(XaxisDates);

    setSeries1([requests, subscriptions, notifications, clicks, ctr])
    setSeries2([profit, subscriptions_percent])

  }, [sortedData])

  return (
    <div id="chart">
        <ReactApexChart
            key={`push-${options.xaxis.categories.join('-')}`}
            options={options}
            series={series1}
            height={350}/>
        <ReactApexChart
            key={`profit-${optionsProfit.xaxis.categories.join('-')}`}
            options={optionsProfit}
            series={series2}
            height={350}/>
    </div>
  )
}


export default ApexChart